export default __webpack_public_path__ + "static/cer@1x-05aa942fb6724548b04efabbfc8d8bc8.png";